// extracted by mini-css-extract-plugin
export default {"container":"home_container__3CYjX","logo":"home_logo__frIlL"};